const questionnaire: any[] = [
    {
        next_route: '/felt-nervous',
        route: '/tired-no-reason',
        label: 'Over the last 30 days, how often have you experienced the following?',
        text: 'Felt tired out for no good reason?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/nervous-uncontrollable',
        route: '/felt-nervous',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt nervous?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/hopeless',
        route: '/nervous-uncontrollable',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt so nervous that nothing could calm you down?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/restless-fidgety',
        route: '/hopeless',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt hopeless?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/restless-cant-sit-still',
        route: '/restless-fidgety',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt restless or fidgety?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/felt-depressed',
        route: '/restless-cant-sit-still',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt so restless you could not sit still?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/everything-effort',
        route: '/felt-depressed',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt depressed?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/sad-nothing-helps',
        route: '/everything-effort',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt that everything was an effort?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/felt-worthless',
        route: '/sad-nothing-helps',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt so sad that nothing could cheer you up?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
    {
        next_route: '/prior-treatment',
        route: '/felt-worthless',
        label: 'Over the past 4 weeks, how often have you experienced the following?',
        text: 'Felt worthless?',
        options: [
            { label: 'None of the time', score: 1 },
            { label: 'A little of the time', score: 2 },
            { label: 'Some of the time', score: 3 },
            { label: 'Most of the time', score: 4 },
            { label: 'All of the time', score: 5 },
        ]
    },
];

export { questionnaire };